{
	"adjustCaptureTime": "Adjust capture time",
	"ariaAdjustPhotoCaptureTime": "Adjust Photo Capture Time",
	"ariaCopyPhotoEdits": "Copy Photo Edits",
	"ariaCreatePhotoVirtualCopy": "Create Photo Virtual Copy",
	"ariaDeletePhotoVirtualCopy": "Delete Photo Virtual Copy",
	"ariaHidePhoto": "Hide Photo",
	"ariaLockPhotoEditing": "Lock Photo Editing",
	"ariaMarkPhotoAsReference": "Mark Photo As AI Style Reference",
	"ariaMoveSelectedPhotosLeft": "Move Selected Photos Left",
	"ariaMoveSelectedPhotosRight": "Move Selected Photos Right",
	"ariaPastePhotoEdits": "Paste Photo Edits",
	"ariaPhotoContextMenu": "Photo Context Menu",
	"ariaReadPhotoXmpMetadata": "Read Photo XMP Metadata",
	"ariaRemovePhoto": "Remove Photo",
	"ariaRemovePhotoReference": "Remove Photo AI Style Reference",
	"ariaSetPhotoColorTag": "Set Photo Color Tag",
	"ariaSetPhotoFlag": "Set Photo Flag",
	"ariaSetPhotoRating": "Set Photo Rating",
	"ariaUnhidePhoto": "Unhide Photo",
	"ariaUnlockPhotoEditing": "Unlock Photo Editing",
	"ariaUpdatePhotoXmpMetadata": "Update Photo XMP Metadata",
	"auto": "Auto",
	"copyEdits": "Copy edits",
	"couldNotLoadYourAccount": "Could not load your account. Please try again.",
	"createVirtualCopy_one": "Create virtual copy",
	"createVirtualCopy_other": "Create {{count}} virtual copies",
	"dialogReadComplete": "Read complete",
	"dialogReadFailed": "Read failed",
	"dialogSaveFailed": "Save failed",
	"dialogSaved": "Metadata saved",
	"exportPhoto_one": "Export photo",
	"exportPhoto_other": "Export {{count}} photos",
	"hidePhoto_one": "Hide photo",
	"hidePhoto_other": "Hide {{count}} photos",
	"lockPhoto_one": "Lock photo",
	"lockPhoto_other": "Lock {{count}} photos",
	"markReference_one": "Mark as reference photo",
	"markReference_other": "Mark {{count}} as reference photos",
	"metadata": "Metadata",
	"move": "Move",
	"none": "None",
	"overrideAiCulling": "Override AI Culling",
	"pasteEdits_one": "Paste edits",
	"pasteEdits_other": "Paste edits to {{count}} photos",
	"publishPhoto_one": "Publish photo",
	"publishPhoto_other": "Publish {{count}} photos",
	"readXmp_one": "Read Metadata from XMP file",
	"readXmp_other": "Read Metadata from XMP files",
	"removePhoto_one": "Remove photo",
	"removePhoto_other": "Remove {{count}} photos",
	"removeReference_one": "Remove reference photo",
	"removeReference_other": "Remove {{count}} from reference photos",
	"removeVirtualCopy_one": "Remove virtual copy",
	"removeVirtualCopy_other": "Remove {{count}} virtual copies",
	"saveXmp_one": "Save Metadata to XMP file",
	"saveXmp_other": "Save Metadata to XMP files",
	"selectedPhoto": "selected photo",
	"setColorLabel": "Set Color Label",
	"setFlag": "Set Flag",
	"setRating": "Set Rating",
	"toTheLeft": "to the left",
	"toTheRight": "to the right",
	"toastCaptureTimeAdjusted": "Capture time adjusted",
	"toastColorRatingCleared": "Color rating cleared",
	"toastFlaggedAsPick_one": "Flagged photo as Pick",
	"toastFlaggedAsPick_other": "Flagged photos as Pick",
	"toastFlaggedAsRejected_one": "Flagged photo as Rejected",
	"toastFlaggedAsRejected_other": "Flagged photos as Rejected",
	"toastHidePhotoCannotHideReferences": "Reference photos cannot be hidden. Please make sure to unselect them or remove them from references.",
	"toastRatedStars_one": "Rated {{count}} star",
	"toastRatedStars_other": "Rated {{count}} stars",
	"toastRemoveFlag": "Remove flag",
	"toastRemovePhotoCannotRemoveReferences": "Reference photos cannot be removed. Please make sure to unselect them or remove them from references.",
	"toastRemovePhotoDeleteFromDisk": "Delete from Disk",
	"toastRemovePhotoHideIn": "Hide in {{productName}}",
	"toastRemovePhotoMessage_one": "This photo will be hidden in {{productName}}. Select 'Delete from Disk' to also delete the selected photo, and associated virtual copies, from your computer permanently. This action is not reversible.",
	"toastRemovePhotoMessage_other": "These photos will be hidden in {{productName}}. Select 'Delete from Disk' to also delete the selected photos, and associated virtual copies, from your computer permanently. This action is not reversible.",
	"toastRemovePhotoTitle_one": "Remove Photo",
	"toastRemovePhotoTitle_other": "Remove {{count}} Photos",
	"toastSetColorRating": "Set color rating to {{color}}",
	"toastSetCullingTag": "Set culling tag to {{tag}}",
	"toastStarRatingCleared": "Star rating cleared",
	"unhidePhoto_one": "Unhide photo",
	"unhidePhoto_other": "Unhide {{count}} photos",
	"unlockPhoto_one": "Unlock photo",
	"unlockPhoto_other": "Unlock {{count}} photos",
	"xmpFileUpdated_one": "XMP file successfully updated.",
	"xmpFileUpdated_other": "XMP files successfully updated.",
	"xmpReadFailed_one": "Failed to read XMP file.",
	"xmpReadFailed_other": "Failed to read XMP files.",
	"xmpReadSuccess_one": "Ratings updated from XMP file.",
	"xmpReadSuccess_other": "Ratings updated from XMP files.",
	"xmpSaveFailed_one": "Failed to update XMP file.",
	"xmpSaveFailed_other": "Failed to update XMP files."
}
